import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function RoleGuard({ role, redirect = "/", children }) {
  const { user, checking } = useAuth();

  if (checking || user === null) {
    return (
      <div className="min-h-screen bg-navy-900 flex items-center justify-center text-white/50 text-sm" data-testid="role-guard-loading">
        Verifying access…
      </div>
    );
  }
  if (!user) return <Navigate to={redirect} replace />;
  if (role && user.role !== role) return <Navigate to={redirect} replace />;
  return children;
}
